type MarkTaskAsCompletedError = {
  completionDateOutOfBound: boolean;
  notFound: boolean;
};

const markTaskAsCompletedError: MarkTaskAsCompletedError = {
  completionDateOutOfBound: false,
  notFound: false,
};

export type { MarkTaskAsCompletedError };

export { markTaskAsCompletedError };
